export default __webpack_public_path__ + "static/media/img.0c2b5a84.jpg";